/**
 * Hover treatment for long carrier notes (the breakdown tables' Notes column).
 *
 * antd's default tooltip caps at 250px wide with no height limit, so a real
 * carrier note — the SunLife shared-limits paragraphs run to hundreds of words —
 * renders as a thin dark column that pours off the bottom of the screen.
 *
 * Width: 560px reads a paragraph in a handful of lines instead of forty.
 * Height: capped at 60% of the viewport with internal scrolling — antd keeps a
 * tooltip open while the cursor is over the overlay itself, so the tail of a
 * note that still doesn't fit is reached by scrolling the popover, never by
 * losing it below the fold. pre-wrap preserves the carrier's own line breaks.
 *
 * Spread onto any `<Tooltip {...NOTE_TOOLTIP_PROPS} title={note}>`.
 */
export const NOTE_TOOLTIP_PROPS = {
  // .ant-tooltip's own max-width lives on the OUTER element; without this the
  // inner style below would be clipped back to 250px.
  overlayStyle: { maxWidth: 560 },
  overlayInnerStyle: {
    maxWidth: 560,
    maxHeight: "60vh",
    overflowY: "auto",
    fontSize: 13,
    lineHeight: 1.6,
    whiteSpace: "pre-wrap",
    padding: "10px 14px",
  },
};
